import { html } from 'lit-element';
import { unsafeHTML } from 'lit-html/directives/unsafe-html';

import { SimpleLitElement } from '@elab/components';
import connect from '@elab/core/store/connect';
import getSelectors from '@elab/core/utils/dynaForms/selectors';
import getActions from '@elab/core/utils/dynaForms/actions';
import { cacheSelector } from '@elab/core/utils/webComponent';

class AddressSuggestionsList extends SimpleLitElement {
    static get properties() {
        return {
            storeName: { type: String },
            suggestions: { type: Array },
            scrollModifier: {
                type: String,
                attribute: 'scroll-modifier',
            },
            highlight: { type: Boolean, reflect: true },
            nestedFormReduxPath: {
                type: String,
                attribute: 'nested-form-redux-path',
            },
        };
    }

    constructor() {
        super();
        this.scrollModifier = '';
        this.suggestions = [];
        this.highlight = false;
        this.nestedFormReduxPath = '';
    }

    handleSelect(suggestion) {
        const event = new CustomEvent('select-address-suggestion', {
            detail: {
                suggestion,
                nestedFormReduxPath: this.nestedFormReduxPath,
            },
        });
        this.dispatchEvent(event);
    }

    highlightText(text) {
        return text.replace(this.sourceValue, `<b>${this.sourceValue}</b>`);
    }

    renderSuggestion(suggestion) {
        const address = this.highlight
            ? this.highlightText(suggestion.formattedAddress)
            : suggestion.formattedAddress;
        return html`
            <li
                class="address-suggestions-list__item"
                @click="${() => this.handleSelect(suggestion)}"
            >
                <span class="address-suggestions-list__text">
                    ${unsafeHTML(address)}
                </span>
            </li>
        `;
    }

    render() {
        return html`
            <div class="address-suggestions-list">
                <e2-scroll
                    reset-last-scroll
                    ?active="${!!this.suggestions.length}"
                    class="scroll ${this.scrollModifier}"
                >
                    <ul class="address-suggestions-list__list">
                        ${this.suggestions.map(this.renderSuggestion, this)}
                    </ul>
                </e2-scroll>
            </div>
        `;
    }
}

const mapStateToProps = (state, ctx) => {
    const selectors = cacheSelector(ctx, getSelectors);
    return {
        suggestions: selectors.getAddressSuggestions(state),
        sourceValue: selectors.getAddressSuggestionsSourceValue(state),
    };
};

const mapDispatchToEvents = (dispatch, ctx) => {
    const actions = getActions(ctx.storeName);
    return {
        'select-address-suggestion': e => dispatch(actions.selectAddressSuggestion(e.detail)),
    };
};

export default () =>
    customElements.define(
        'e2-address-suggestions-list',
        connect(mapStateToProps, mapDispatchToEvents)(AddressSuggestionsList),
    );
